import { AbstractControl, FormControl } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";

export function requiredIfFieldsValidator(control: AbstractControl, form: FormlyFieldConfig, options: any = {}) {
    const model = control.value;

    switch(options.data.condition){
        case 'notEmpty':
            let countNotEmpty = 0;

            options.data.fields.forEach((fieldName: string) => {
                if(
                    !!model[fieldName] &&
                    model[fieldName].trim() !== ''
                ) {
                    countNotEmpty++;
                }
            });

            if(countNotEmpty === options.data.fields.length){
                return {
                    'requiredIfFields': {
                        message: options.data.message || 'Required field'
                    }
                };
            }

            break;
        case 'equals':
            if(options.data.values.includes(model[options.data.field])){
                return {
                    'requiredIfFields': {
                        message: options.data.message || 'Required field'
                    }
                };
            }
            break;
    }

    return null;
}